
















































import Vue from 'vue';
import ANIData from './util/ANIData';

export default Vue.extend({
  name: 'App',
  data: () => ({
    aniOrdered: false,
    aniPasted: false,
    aniData: {} as ANIData,
    displayedTable: {} as HTMLTableElement,
    undisplayedTable: {} as HTMLTableElement,
    summary: '',
  }),
  mounted() {
    (this.$refs.ANI as HTMLElement).addEventListener('paste', (e) => {
      if (this.aniPasted) {
        return;
      }
      e.preventDefault();
      const pastedHTMLText = e.clipboardData?.getData('text/html');
      if (pastedHTMLText) {
        (this.$refs.ANI as HTMLElement).innerHTML = pastedHTMLText;
        this.handlePastedHtml(pastedHTMLText);
      }
    });
  },
  methods: {
    handlePastedHtml(htmlText: string) {
      const html = new DOMParser().parseFromString(htmlText, 'text/html');
      const tableWithinHTML = html.querySelector('table');
      if (tableWithinHTML) {
        this.displayedTable = tableWithinHTML;
        this.aniData = new ANIData(tableWithinHTML);
        this.createSummary();
        this.aniPasted = true;
      }
    },
    reorder() {
      this.undisplayedTable = this.displayedTable;
      this.displayedTable = this.aniData.reorderedTable();
      this.aniOrdered = true;
    },

    unorder() {
      const undisplayed = this.undisplayedTable;
      this.undisplayedTable = this.aniData.reorderedTable();
      this.displayedTable = undisplayed;
      this.aniOrdered = false;
    },

    createSummary() {
      const summary = [];
      summary.push('Affirmative Summary:<br>');
      summary.push('<ul>');
      summary.push(...this.aniData.AColumn.summary);
      summary.push('</ul><br>');
      summary.push('Negative Summary:<br>');
      summary.push('<ul>');
      summary.push(...this.aniData.NColumn.summary);
      summary.push('</ul>');
      this.summary = summary.join('');
    },

    clear() {
      this.displayedTable = {} as HTMLTableElement;
      this.undisplayedTable = {} as HTMLTableElement;
      const ANI = this.$refs.ANI as HTMLElement;
      ANI.innerHTML = '';
      this.aniPasted = false;
      this.aniOrdered = false;
      this.summary = '';
      this.aniData = {} as ANIData;
    },
  },

  watch: {
    displayedTable() {
      const currentTable = (this.$refs.ANI as HTMLElement).querySelector('table');
      if (currentTable) {
        const currentTableParent = currentTable.parentElement;
        if (currentTableParent) {
          currentTable.remove();
          currentTableParent.appendChild(this.displayedTable);
        }
      }
    },
  },
});
